import { Utils } from './../../../../core/utils/utils';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialogs-confirm',
  templateUrl: './dialogs-confirm.component.html',
  styleUrls: ['./dialogs-confirm.component.scss']
})
export class DialogsConfirmComponent implements OnInit {

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() private dialogRef: MatDialogRef<DialogsConfirmComponent>,
              public translate: TranslateService) { }

  texto: string = "";
  textoOk: string = "";
  textoNoOk: string = "";

  ngOnInit() {
    this.texto = this.data.texto;
    this.textoOk = Utils.noUndfAndNull(this.data.textoOk, "", false) ? this.data.textoOk : this.translate.instant("aceptar");
    this.textoNoOk = Utils.noUndfAndNull(this.data.textoNoOk, "", false) ? this.data.textoNoOk : this.translate.instant("cancelar");
  }

  /**
  * @description
  * Cierra el dialog
  */
  aceptar() {
    this.dialogRef.close(true);
  }

}
